import { supabase } from '@/lib/supabase/client';
import { createContactsService } from '@/lib/contacts/contract';
export type { Contact, ContactInsert, ContactUpdate } from '@/lib/contacts/contract';
export { ContactError } from '@/lib/contacts/contract';
let sessionGeneration = 0;
let sessionIdentity: string | null = null;
export const contactsService = createContactsService((name, args) => supabase.rpc(name, args), () => sessionGeneration);
supabase.auth.onAuthStateChange((_event, session) => {
  const next = session?.user.id ?? null;
  if (next !== sessionIdentity) { sessionIdentity = next; sessionGeneration += 1; contactsService.resetRecovery(); }
});
